import { Stack } from '@chakra-ui/react'
import MonthlyReportHeader from '../../../components/MonthlyReportHeader'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'
import MonthlyReportNavButtons from '../../../components/MonthlyReportNavButtons'
import useReportMonthGuard from '../../../hooks/useReportMonthGuard'
import { useMentalStrategiesFormState } from './hooks/useMentalStrategiesFormState'
import { MentalRegimens } from './components/MentalRegimens'

export const MentalStrategiesPage = () => {
  const isValidated = useReportMonthGuard()
  const { handleSubmit, lists } = useMentalStrategiesFormState()
  const purpleBubbleContent = usePurpleBubblesText('Step-11')

  if (!isValidated) {
    return null // Don't render anything until month is validated
  }

  return (
    <Stack spacing={4}>
      <form onSubmit={handleSubmit}>
        <MonthlyReportHeader title='Mind Strategies' />
      </form>
      {purpleBubbleContent?.text && (
        <PurpleBubbleContent text={purpleBubbleContent.text} />
      )}
      <MentalRegimens lists={lists} />
      <form onSubmit={handleSubmit}>
        <MonthlyReportNavButtons />
      </form>
    </Stack>
  )
}
